import {
  useLocation,
  InteractionTrackingProvider,
  ClickTrackingRoot,
  ErrorBoundary,
} from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as PageKindModule from "../routing/pageKind.js";
import * as AppProvidersModule from "../i18n/AppProviders.jsx";
import { RateLimitPopup } from "../components/RateLimitPopup.jsx";
import { InviteCodeModal } from "../components/InviteCodeModal.jsx";
import { AnnouncementBanner } from "../components/AnnouncementBanner.jsx";
import { DesktopNav } from "../components/navigation/DesktopNav.jsx";
import { MobileNav } from "../components/navigation/MobileNav.jsx";
import { DocsTopNav } from "../components/navigation/DocsTopNav.jsx";
import { DocsMobileNav } from "../components/navigation/DocsMobileNav.jsx";
import { PageRoutes } from "../routing/PageRoutes.jsx";
import { Footer } from "../components/Footer.jsx";
function App() {
  let { pathname: pathname } = useLocation(),
    t = (0, PageKindModule.usesPageBackground)(pathname),
    i = "/" === pathname || "/home" === pathname;
  return (
    <AppProvidersModule.AppProviders>
      <InteractionTrackingProvider instance={"mimo"}>
        <ClickTrackingRoot>
          <RateLimitPopup />
          <InviteCodeModal />
          <div
            className={`flex flex-col h-full ${t ? "bg-[var(--color-bg-page)]" : ""}`}
          >
            <div id={"page-container"} />
            <AnnouncementBanner />
            {!i && <DesktopNav />}
            {!i && <MobileNav />}
            <div className={"hidden lg:block w-full"}>
              <DocsTopNav />
            </div>
            <DocsMobileNav />
            <ErrorBoundary fallbackRender={() => <div />}>
              <main
                className={
                  "flex-1 overflow-auto flex flex-col w-full items-center"
                }
              >
                <PageRoutes />
                <Footer />
              </main>
              {""}
            </ErrorBoundary>
          </div>
        </ClickTrackingRoot>
      </InteractionTrackingProvider>
    </AppProvidersModule.AppProviders>
  );
}
export { App };
